import { FunctionComponent } from 'react';
import { NoValue } from '../../../sharedComponents/NoValue';
import { DateTime } from '../../../sharedComponents/table/BaseTableComponents';
import { DepartedVehicle, Departure, ExpectedDeparture, OutgoingVehicle } from '../../compoundManagement.types';
import { DisplayCancellableData } from './DisplayCancellableData';

type DisplayDepartureProps = {
    compoundVehicle: OutgoingVehicle | DepartedVehicle;
};

export const DisplayDepartureDate: FunctionComponent<{ compoundVehicle: DepartedVehicle }> = ({ compoundVehicle }) => {
    return (
        <DisplayCancellableData isCancelled={compoundVehicle.departure.isCancelled}>
            <DateTime
                dateTime={compoundVehicle.departure.departureCompletedAt}
                timeZone={compoundVehicle.compoundLocation.timeZone}
            />
        </DisplayCancellableData>
    );
};

export const DisplayDepartureFreightForwarder = (props: { departure: ExpectedDeparture | Departure }) => {
    const freightForwarder = props.departure?.freightForwarder;
    return freightForwarder ? (
        <DisplayCancellableData isCancelled={props.departure.isCancelled}>
            <span className="ellipsis-1">
                {freightForwarder.name} {freightForwarder.additionalName}
            </span>
        </DisplayCancellableData>
    ) : (
        <NoValue />
    );
};

export const DisplayDepartureToLocationId: FunctionComponent<DisplayDepartureProps> = ({ compoundVehicle }) => {
    const departureToLocationId = compoundVehicle.departure.departureTo?.identifier;
    return departureToLocationId ? (
        <DisplayCancellableData isCancelled={compoundVehicle.departure.isCancelled}>
            {departureToLocationId}
        </DisplayCancellableData>
    ) : (
        <NoValue />
    );
};

export const DisplayDepartureToCity: FunctionComponent<DisplayDepartureProps> = ({ compoundVehicle }) => {
    const departureToCity = compoundVehicle.departure.departureTo?.address?.city;
    return departureToCity ? (
        <DisplayCancellableData isCancelled={compoundVehicle.departure.isCancelled}>
            {departureToCity}
        </DisplayCancellableData>
    ) : (
        <NoValue />
    );
};
